import { Component, EventEmitter, Output } from '@angular/core';
import { VedraxBaseComponent } from '../vedrax-base.component';

/**
 * Class that defines a generic component according to the control type
 */
@Component({
  selector: 'vedrax-control',
  templateUrl: './vedrax-control.component.html'
})
export class VedraxControlComponent extends VedraxBaseComponent {

  /**
* Emit number of options when all of them are available
*/
  @Output() isReady: EventEmitter<boolean> = new EventEmitter();

  checkIfOptionsAvailable(optionsNb: number) {
    if(optionsNb > 0){
      this.isReady.emit(true);
    }
  }

          

}
